import AddIcCallIcon from '@mui/icons-material/AddIcCall';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from 'components/Button/Button';
import IconButton from 'components/IconButton/IconButton';
import React, { useState } from 'react';
import { getName } from '../../../utils';
import CallTransfer from './CallTransfer';
import CallerID from './CallerID';

const ExternalCall = ({ call, onClose }) => {
  const [showTransfer, setShowTransfer] = useState(false);

  const onAddCaller = () => {
    onClose();
  };

  if (showTransfer) {
    return (
      <CallTransfer
        onAdded={onAddCaller}
        onClose={() => setShowTransfer(false)}
        callSid={call.call_sid}
        callHash={call.hash}
      />
    );
  }
  return (
    <Box textAlign="center" p={3}>
      <Stack
        p={0}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography fontWeight={500}>Call in progress</Typography>
        <IconButton icon={<CloseIcon />} onClick={onClose} />
      </Stack>
      <CallerID
        name={getName(call.contact)}
        from={call.contact.primary_phone}
      />
      <Stack direction="row" justifyContent="space-around" spacing={3}>
        <Stack spacing={0.5} alignItems="center">
          <Button
            onClick={() => setShowTransfer(true)}
            size="large"
            variant="outlined"
          >
            <AddIcCallIcon sx={{ color: '#3F0E80' }} />
          </Button>
          <Typography variant="body2">Transfer</Typography>
        </Stack>
      </Stack>
    </Box>
  );
};

export default ExternalCall;
